import { combineReducers } from 'redux';

import amp from 'app/AMPModal/duck';
import app from 'app/App/reducer';
import { componentReducer as component } from 'app/CanvasComponent/reducer';
import { componentUsageReducer as usage } from 'app/ComponentUsage/reducer';
import editorPane from 'app/EditorPane/reducer';
import experiments from 'app/Experiments/reducer';
import explorer from 'app/Explorer/reducer';
import notifications from 'app/Notifications/reducer';
import page from 'app/Page/reducer';
import { previewPaneReducer as context } from 'app/PreviewPane/reducer';
import reports from 'app/Reports/duck';
import { renderingEnvReducer as renderingEnv } from 'app/RenderingEnvironment/reducer';
import search from 'app/Search/reducer';
import tree from 'app/Tree/reducer';
import { userReducer as user } from 'app/UserInfo/reducer';

const canvas = combineReducers({ component, context, usage });

export default {
  amp,
  app,
  canvas,
  editorPane,
  experiments,
  explorer,
  notifications,
  page,
  reports,
  search,
  tree,
  user,
  renderingEnv
};
